import { render, staticRenderFns } from "./Slickcarousel.vue?vue&type=template&id=f638ee20&scoped=true"
import script from "./Slickcarousel.vue?vue&type=script&lang=js"
export * from "./Slickcarousel.vue?vue&type=script&lang=js"
import style0 from "./Slickcarousel.vue?vue&type=style&index=0&id=f638ee20&prod&scoped=true&lang=css"
import style1 from "./Slickcarousel.vue?vue&type=style&index=1&id=f638ee20&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f638ee20",
  null
  
)

export default component.exports